
define('text!widgets/paymentMethodSelector/view.html',[],function () { return '<div class="payment-method-selector" data-bind="click: open">\n    <span class="selected-method bold">{{selectionText}}</span><span class="icon icons-direction-down"></span>\n</div>';});

